import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  generatePasswordFormWrapper: {
    padding: theme.spacing(0, 57.5),
    boxSizing: 'content-box',
    textAlign: 'center',
    maxWidth: theme.spacing(221.5),

    '& h1, h2, h3': {
      fontFamily: 'Roboto',
      textAlign: 'center',
      color: '#233B58',
    },

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(30),
    },

    [theme.breakpoints.down('sm')]: {
      boxSizing: 'border-box',
      padding: theme.spacing(20, 15),
    },
  },
  passwordContainer: {
    marginTop: theme.spacing(50),

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(26),
    },
  },
  title: {
    fontSize: theme.spacing(20),
    lineHeight: theme.spacing(24) + 'px',
    fontWeight: theme.spacing(250),

    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(16),
      lineHeight: theme.spacing(19) + 'px',
    },
  },
}));
